const Reflux = require('@muzzylane/reflux');

const _ = {
    get: require('lodash/get'),
};

const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const AssetUtil = require('../util/asset');

const OrganizationActions = Reflux.createActions({
    registerOrganization: { children: ['completed', 'failed'] },
    validateOrganization: { children: ['completed', 'failed'] },
    setOrganizationPermission: { children: ['completed', 'failed'] },
    removeOrganizationMember: { children: ['completed', 'failed'] },
    orgInfo: { children: ['completed', 'failed'] },
    getMembers: { children: ['completed', 'failed'] },
    getOrgInfoFull: { children: ['completed', 'failed'] },
    getOrgApiInfo: { children: ['completed', 'failed'] },
    updateOrgInfo: { children: ['completed', 'failed'] },
    getOrgIntegrationTags: { children: ['completed', 'failed'] },
    addOrgIntegrationTag: { children: ['completed', 'failed'] },
    updateOrgIntegrationTag: { children: ['completed', 'failed'] },
    deleteOrgIntegrationTag: { children: ['completed', 'failed'] },
    manageOrgIntegrationTag: { children: ['completed', 'failed'] },
    importIntegrationTagsCsv: { children: ['completed', 'failed'] },
    clearImportIntegrationTagChanges: { children: ['completed'] },
    confirmImportIntegrationTagChanges: { children: ['completed', 'failed'] },
    importActMetaTagsCsv: { children: ['completed', 'failed'] },
    clearImportActMetaTagChanges: { children: ['completed'] },
    confirmImportActMetaTagChanges: { children: ['completed', 'failed'] },
    getOrgUserSettings: { children: ['completed', 'failed'] },
    updateOrgUserSettings: { children: ['completed', 'failed'] },
    updateOrgCustomConfig:  { children: ['completed', 'failed'] },
    getOrgPrivacyPolicies: { children: ['completed', 'failed'] },
    addOrgPrivacyPolicy: { children: ['completed', 'failed'] },
    updateOrgPrivacyPolicy: { children: ['completed', 'failed'] },
    deleteOrgPrivacyPolicy: { children: ['completed', 'failed'] },
    getOrgJsonAssets: { children: ['completed', 'failed'] },
    addOrgAsset: { children: ['completed', 'failed'] },
    getOrgStudentFeedback: { children: ['completed', 'failed'] },
    updateOrgStudentFeedback: { children: ['completed', 'failed'] },
    getOrgAccountFeatures: { children: ['completed', 'failed'] },
    updateOrgAccountFeatures: { children: ['completed', 'failed'] },
    getOrgBoilerplate: { children: ['completed', 'failed'] },
    updateOrgBoilerplateEntry: { children: ['completed', 'failed'] },
});

OrganizationActions.registerOrganization.listen(function(actionID, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if(!params.email) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
    }

    if(!params.ownerEmail) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("owner_email");
    }

    if(!params.organizationName) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("organization_name");
    }

    if(!params.org_plan_id) {
        // console.log("params.org_plan_id: " + params.org_plan_id);
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("org_plan_id");
    }

    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/register/organization', 'POST', JSON.stringify({
            email: params.email,
            owner_email: params.ownerEmail,
            organization_name: params.organizationName,
            org_plan_id: params.org_plan_id,
            // account_type: params.accountType
        }))
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});

OrganizationActions.validateOrganization.listen(function(actionID, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if(!params.secret){
        valid = false;
        errorMsg = ErrorConsts.MISSING_SECRET;
    }

    if(valid && !params.password){
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("password");
    }

    if(valid && !params.passwordConfirm){
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("passwordConfirm");
    }

    if(valid && !params.displayName){
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("displayName");
    }

    if(valid && params.password !== params.passwordConfirm){
        valid = false;
        errorMsg = ErrorConsts.PASSWORD_MATCH;
        errorUIRefs.push("password", "passwordConfirm");
    }

    if(valid && (params.password.length < 8)){
        valid = false;
        errorMsg = ErrorConsts.PASSWORD_LENGTH;
        errorUIRefs.push("password", "passwordConfirm");
    }

    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/organization/validate', 'POST', JSON.stringify({
            secret: params.secret,
            password: params.password,
            display_name: params.displayName
        }))
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});


OrganizationActions.setOrganizationPermission.listen(function(actionID, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if(!params.orgId) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS; //different error message? this shouldn't really be under the control of the user.
    }

    if(!params.email) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("email");
    }

    if(!params.role) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("role");
    }

    if(!valid){
        this.failed(actionID, params.orgId, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/organization/' + params.orgId + '/permission', 'POST', JSON.stringify({
            email: params.email,
            role: params.role
        }))
        .then(function(res) {self.completed(actionID, params.orgId, res)})
        .catch(function(err) {self.failed(actionID, params.orgId, err)});
});

OrganizationActions.removeOrganizationMember.listen(function(actionID, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if(!params.orgId) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS; //different error message? this shouldn't really be under the control of the user.
    }

    if(!params.userId) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("userId");
    }

    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/organization/' + params.orgId + '/remove/member', 'POST', JSON.stringify({
            userId: params.userId
        }))
        .then(function(res) {self.completed(actionID, params.orgId, params.userId, res)})
        .catch(function(err) {self.failed(actionID, params.orgId, params.userId, err)});
});


OrganizationActions.orgInfo.listen(function(actionID, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if(!params.secret) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_SECRET;
    }

    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/organization/info/' + params.secret, 'GET')
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});

OrganizationActions.getMembers.listen(function(actionID, params) {
    const self = this;

    if(!params.id) {
        this.failed(actionID, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
    }

    ServerRequest.makeRequest('/authoring/organization/' + params.id + '/members', 'GET')
        .then(function(res) {self.completed(actionID, params.id, res)})
        .catch(function(err) {self.failed(actionID, params.id, err)});
});

OrganizationActions.getOrgInfoFull.listen(function(actionID, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if(!params.id) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
    }

    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/users?id='+params.id, 'GET')  //TODO: replace with more specific org user server API
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});


OrganizationActions.getOrgApiInfo.listen(function(actionID, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if (!params.id) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
    }

    if (!valid){
        this.failed(actionID, new ForgeError({ message: errorMsg, uiRefs: errorUIRefs }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/organization/${params.id}/api`, 'GET')
    .then((res) => { self.completed(actionID, params.id, res); })
    .catch((err) => { self.failed(actionID, params.id, err); });
});

OrganizationActions.updateOrgInfo.listen(function(actionID, params) {
    const self = this;

    console.log('in action', params);

    if(!params.orgId) {
        console.log('not orgid')
        this.failed(actionID, params.orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    let updatedInfo = {};

    if (!!params.displayName) {
        updatedInfo.display_name = params.displayName;
    }

    if (!!params.password) {
        updatedInfo.password = params.password;
    }

    ServerRequest.makeRequest(`/authoring/user/${params.orgId}/update`, 'PUT', JSON.stringify(updatedInfo))
        .then(function(res) {self.completed(actionID, params.orgId, res)})
        .catch(function(err) {self.failed(actionID, params.orgId, err)});
});


OrganizationActions.getOrgIntegrationTags.listen(function(actionId, params) {
    if (!params.orgId) {
        this.failed(actionId, params.orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const self = this;
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/integration_tags`, 'GET')
    .then(res => self.completed(actionId, params.orgId, res))
    .catch(err => self.failed(actionId, params.orgId, err));
});

OrganizationActions.addOrgIntegrationTag.listen(function(actionId, params) {
    if (!params.orgId || !params.tag) {
        this.failed(actionId, params.orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const self = this;
    const updatedInfo = {
        tag: params.tag,
        description: params.description,
    };
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/integration_tags`, 'PUT', JSON.stringify(updatedInfo))
    .then(res => self.completed(actionId, params.orgId, res))
    .catch(err => self.failed(actionId, params.orgId, err));
});

OrganizationActions.updateOrgIntegrationTag.listen(function(actionId, params) {
    if (!params.orgId || !params.tagId) {
        this.failed(actionId, params.orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const self = this;
    let updatedInfo = {};
    if (!!params.tag) {
        updatedInfo.tag = params.tag;
    }

    if (typeof params.description === 'string') {
        updatedInfo.description = params.description;
    }

    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/integration_tags/${params.tagId}`, 'PATCH', JSON.stringify(updatedInfo))
    .then(res => self.completed(actionId, params.orgId, res))
    .catch(err => self.failed(actionId, params.orgId, err));
});

OrganizationActions.deleteOrgIntegrationTag.listen(function(actionId, params) {
    if (!params.orgId || !params.tagId) {
        this.failed(actionId, params.orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const self = this;
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/integration_tags/${params.tagId}`, 'DELETE')
    .then(res => self.completed(actionId, params.orgId, params.tagId, res))
    .catch(err => self.failed(actionId, params.orgId, params.tagId, err));
});

OrganizationActions.manageOrgIntegrationTag.listen(function(actionId, params) {
    if (!params.orgId || !params.tagId || !params.managementTasks) {
        this.failed(actionId, params.orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const self = this;
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/integration_tags/${params.tagId}/manage`, 'POST', JSON.stringify(params.managementTasks))
    .then(tagInfo => self.completed(actionId, params.orgId, params.managementTasks, tagInfo))
    .catch(err => self.failed(actionId, params.orgId, params.managementTasks, err));
});

OrganizationActions.importIntegrationTagsCsv.listen(function(actionId, params, files) {
    if (!params.orgId) {
        this.failed(actionId, params.orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const self = this;
    ServerRequest.makeUploadRequest(`/authoring/organization/${params.orgId}/integration_tags/csv`, 'POST', params, files, AssetUtil.validateCsvMimeType)
    .then(res => self.completed(actionId, params.orgId, res))
    .catch(err => self.failed(actionId, params.orgId, err));
});

OrganizationActions.clearImportIntegrationTagChanges.listen(function(actionId, params, files) {
    this.completed(actionId, params.orgId);
});

OrganizationActions.confirmImportIntegrationTagChanges.listen(function(actionId, params, files) {
    if (!params.orgId) {
        this.failed(actionId, params.orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const self = this;
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/integration_tags/import_confirm`, 'POST', JSON.stringify(params.operations))
    .then(res => self.completed(actionId, params.orgId, res))
    .catch(err => self.failed(actionId, params.orgId, err));
});

OrganizationActions.importActMetaTagsCsv.listen(function(actionId, params, files) {
    if (!params.orgId || !params.categoryId) {
        this.failed(actionId, params.orgId, params.categoryId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeUploadRequest(`/authoring/organization/${params.orgId}/activity_tags/${params.categoryId}/csv`, 'POST', params, files, AssetUtil.validateCsvMimeType)
        .then(res => this.completed(actionId, params.orgId, params.categoryId, res))
        .catch(err =>this.failed(actionId, params.orgId, params.categoryId, err));
});

OrganizationActions.clearImportActMetaTagChanges.listen(function(actionId, params) {
    this.completed(actionId, params.orgId, params.categoryId);
});

OrganizationActions.confirmImportActMetaTagChanges.listen(function(actionId, params, files) {
    if (!params.orgId || !params.categoryId) {
        this.failed(actionId, params.orgId, params.categoryId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_tags/${params.categoryId}/import_confirm`, 'POST', JSON.stringify(params.operations))
        .then(res => this.completed(actionId, params.orgId, params.categoryId, res))
        .catch(err => this.failed(actionId, params.orgId, params.categoryId, err));
});

OrganizationActions.getOrgUserSettings.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/settings`, 'GET')
        .then(res => this.completed(actionId, params.orgId, res))
        .catch(err => this.failed(actionId, params.orgId, err));
});

OrganizationActions.updateOrgUserSettings.listen(function(actionId, params) {
    let changes = {
        enableShareLinks: params.enableShareLinks,
        enableStudentFeedback: params.enableStudentFeedback,
    };
    if (params.customConfig) {
        changes.customConfig = params.customConfig;
    }
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/settings`, 'PATCH', JSON.stringify(changes))
        .then(res => this.completed(actionId, params.orgId, res))
        .catch(err => this.failed(actionId, params.orgId, err));
});

// note: admin required 
OrganizationActions.updateOrgCustomConfig.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/custom_config`, 'PATCH', JSON.stringify({customConfig:params.customConfig}))
        .then(res => this.completed(actionId, params.orgId, res))
        .catch(err => this.failed(actionId, params.orgId, err));
});

OrganizationActions.getOrgPrivacyPolicies.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/channels/${params.orgId}/privacy_policies`, 'GET')
        .then(res => this.completed(actionId, params.orgId, res))
        .catch(err => this.failed(actionId, params.orgId, err));
});

OrganizationActions.addOrgPrivacyPolicy.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/channels/${params.orgId}/privacy_policies/create`, 'POST', JSON.stringify({
            name: params.name,
            data: params.data,
        }))
        .then(res => this.completed(actionId, params.orgId, res))
        .catch(err => this.failed(actionId, params.orgId, err));
});

OrganizationActions.updateOrgPrivacyPolicy.listen(function(actionId, params) {
    const args = {};
    if (typeof params.name === 'string') args.name = params.name;
    if (!!params.data) args.data = params.data;
    ServerRequest.makeRequest(`/authoring/channels/${params.orgId}/privacy_policies/${params.privacyPolicyId}`, 'PATCH', JSON.stringify(args))
        .then(res => this.completed(actionId, params.orgId, params.privacyPolicyId, res))
        .catch(err => this.failed(actionId, params.orgId, params.privacyPolicyId, err));
});

OrganizationActions.deleteOrgPrivacyPolicy.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/channels/${params.orgId}/privacy_policies/${params.privacyPolicyId}`, 'DELETE', JSON.stringify({}))
        .then(res => this.completed(actionId, params.orgId, params.privacyPolicyId, res))
        .catch(err => this.failed(actionId, params.orgId, params.privacyPolicyId, err));
});

OrganizationActions.getOrgJsonAssets.listen(function(actionId, orgId) {
    const self = this;
    if (!orgId) {
        this.failed(actionId, orgId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    ServerRequest.makeRequest(`/authoring/org_assets/${orgId}/json`, 'GET')
        .then((res)=>{self.completed(actionId, orgId, res)})
        .catch(err => self.failed(actionId, orgId, err));
});

OrganizationActions.addOrgAsset.listen(function(actionId, params, files) {
    const self = this;
    if (!params.assetType || ! params.org_id) {
        this.failed(actionId, params, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    var validator = AssetUtil.validatorMap[params.assetType];
    if (!validator) {
        this.failed(actionId, params, new ForgeError({ message: `Unrecognized assetType: "${params.assetType}"`}));
        return;
    }

    ServerRequest.makeUploadRequest('/authoring/create_org_asset', 'POST', params, files, validator)
        .then((res)=>{
            self.completed(actionId, params, res);
        })
        .catch(err => self.failed(actionId, params, err));
});

OrganizationActions.getOrgStudentFeedback.listen(function(actionId, orgId, params) {
    const page = _.get(params, 'page', '1');
    const commentSearchTerm = _.get(params, 'commentSearchTerm','');
    const categorySearchTerm = _.get(params, 'categorySearchTerm',null);
    const sortBy = _.get(params, 'sortBy', '');
    const sortOrder = _.get(params, 'sortOrder', '');
    let data = {
        page,
        commentSearchTerm,
        categorySearchTerm,
        sortBy,
        sortOrder
    };
    
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/feedback_comments`, 'POST',JSON.stringify(data))
        .then((res)=>{ this.completed(actionId, orgId, res) })
        .catch((err)=>{ this.failed(actionId, orgId, err) });
});

OrganizationActions.updateOrgStudentFeedback.listen(function(actionId, orgId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/update_feedback_comment`, 'POST',JSON.stringify(params))
        .then((res)=>{ this.completed(actionId, orgId, res) })
        .catch((err)=>{ this.failed(actionId, orgId, err) });
});

OrganizationActions.getOrgAccountFeatures.listen(function(actionId, orgId) {
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/account_features`, 'GET')
        .then((res)=>{ this.completed(actionId, orgId, res) })
        .catch((err)=>{ this.failed(actionId, orgId, err) });
});

OrganizationActions.updateOrgAccountFeatures.listen(function(actionId, orgId, accountFeatures) {
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/account_features`, 'PUT',JSON.stringify({accountFeatures}))
        .then((res)=>{ this.completed(actionId, orgId, res) })
        .catch((err)=>{ this.failed(actionId, orgId, err) });
});


OrganizationActions.getOrgBoilerplate.listen(function(actionId, orgId) {
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/ai_boilerplate`, 'GET')
        .then((res)=>{ this.completed(actionId, orgId, res) })
        .catch((err)=>{ this.failed(actionId, orgId, err) });
});

OrganizationActions.updateOrgBoilerplateEntry.listen(function(actionId, orgId, string_id, string_value) {
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/ai_boilerplate`, 'PUT',JSON.stringify({string_id, string_value}))
        .then((res)=>{ this.completed(actionId, orgId, res) })
        .catch((err)=>{ this.failed(actionId, orgId, err) });
});

module.exports = OrganizationActions;